import io from 'socket.io-client';
import _ from 'lodash';
import { SOCKET, SUCCESS } from 'flaivy-react/reducers/action-type';
import { ACTION_TYPES as AUTH_ACTION_TYPES } from 'flaivy-react/reducers/auth.reducer';

import { getAxiosInstanceWithoutErrorChecking } from '../../config/api';

import pluralize from 'pluralize';

export default function socketMiddleware() {
  let socket = null;
  function attach(dispatch, loggedInUser) {
    socket = io({
      // WARNING: in that case, there is no fallback to long-polling
      transports: ['websocket'], // or [ "websocket", "polling" ] (the order matters)
    });

    const listen = async (eventName, event) => {
      if (!event.entityId) {
        return;
      }

      let fullEntity;
      if (!event.eventParams) {
        try {
          const instance = getAxiosInstanceWithoutErrorChecking();
          fullEntity = (
            await instance.get(
              `private/${pluralize.plural(event.entityModel)}/${
                event.entityId
              }`,
            )
          ).data;
        } catch (e) {
          // we might not be able to fetch the entity based on access rules
          console.log('error', e);
        }
      }
      dispatch({
        type: SOCKET(eventName),
        payload: {
          eventName,
          eventParams: event.eventParams,
          fullEntity,
          loggedInUser,
          userId: event.userId,
          sessionUser: event.sessionUser,
        },
      });
    };

    const originalOnEvent = socket.onevent;

    // Below function creates a handler for all events.
    // https://stackoverflow.com/questions/10405070/socket-io-client-respond-to-all-events-with-one-handler
    socket.onevent = function (packet) {
      const args = packet.data || [];
      originalOnEvent.call(this, packet); // original call
      packet.data = ['*'].concat(args);
      originalOnEvent.call(this, packet); // additional call to catch-all
    };

    socket.on('*', listen);
  }

  function detach() {
    socket.disconnect();
  }

  return store => next => {
    const { authentication } = store.getState();

    if (authentication.isAuthenticated) {
      attach(store.dispatch, authentication.sessionUser, store);
    }
    return action => {
      switch (action.type) {
        case SUCCESS(AUTH_ACTION_TYPES.LOGIN):
          attach(store.dispatch, action.payload.data, store);
          break;
        case AUTH_ACTION_TYPES.CHANGE_ACTIVE_MEMBERSHIP:
          detach();
          attach(store.dispatch, action.payload.data, store);
          break;
        case AUTH_ACTION_TYPES.LOGOUT:
          detach(authentication.sessionUser);
          break;
        default:
      }
      return next(action);
    };
  };
}